//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import glhHeader from '~/components/public/glh-header';
import bindPhoneMixin from '~/mixins/bind-phone.js';
import logs from '~/mixins/logs.js';
export default {
  components: {
    glhFooter: () => import('~/components/public/glh-footer'),
    glhHeader,
    Login: () => import('~/components/public/login/index'),
    OrderDialog: () => import('~/components/member/order-dialog/index'),
  },
  mixins: [bindPhoneMixin, logs],
};
